const countries = [
  { name: 'Afghanistan', code: 'AF', nation: 'Afghan' },
  { name: 'Åland Islands', code: 'AX', nation: 'Ålandish' },
  { name: 'Albania', code: 'AL', nation: 'Albanian' },
  { name: 'Algeria', code: 'DZ', nation: 'Algerian(s)' },
  { name: 'American Samoa', code: 'AS', nation: 'US nationals' },
  { name: 'AndorrA', code: 'AD', nation: 'Andorran' },
  { name: 'Angola', code: 'AO', nation: 'Angolan' },
  { name: 'Anguilla', code: 'AI', nation: 'Anguillan' },
  { name: 'Antarctica', code: 'AQ', nation: 'Antarctica' },
  { name: 'Antigua and Barbuda', code: 'AG', nation: 'Antiguan Barbudan' },
  { name: 'Argentina', code: 'AR', nation: 'Argentinean' },
  { name: 'Armenia', code: 'AM', nation: 'Armenian' },
  { name: 'Aruba', code: 'AW', nation: 'Aruban' },
  { name: 'Australia', code: 'AU', nation: 'Australian (Australia)' },
  { name: 'Austria', code: 'AT', nation: 'Austrian' },
  { name: 'Azerbaijan', code: 'AZ', nation: 'Azerbaijani' },
  { name: 'Bahamas', code: 'BS', nation: 'Bahamian' },
  { name: 'Bahrain', code: 'BH', nation: 'Bahraini' },
  { name: 'Bangladesh', code: 'BD', nation: 'Bangladeshis' },
  { name: 'Barbados', code: 'BB', nation: 'Barbadian' },
  { name: 'Belarus', code: 'BY', nation: 'Belarusian' },
  { name: 'Belgium', code: 'BE', nation: 'Belgian' },
  { name: 'Belize', code: 'BZ', nation: 'Belizean' },
  { name: 'Benin', code: 'BJ', nation: 'Dahomey' },
  { name: 'Bermuda', code: 'BM', nation: 'Bermudian' },
  { name: 'Bhutan', code: 'BT', nation: 'Bhutia' },
  { name: 'Bolivia', code: 'BO', nation: 'Bolivian' },
  { name: 'Bosnia and Herzegovina', code: 'BA', nation: 'Bosnian' },
  { name: 'Botswana', code: 'BW', nation: 'Batswana' },
  { name: 'Bouvet Island', code: 'BV', nation: 'Bouvet Island' },
  { name: 'Brazil', code: 'BR', nation: 'Brazilian' },
  { name: 'British Indian Ocean Territory', code: 'IO', nation: 'BIOT' },
  { name: 'Brunei Darussalam', code: 'BN', nation: 'Bruneian' },
  { name: 'Bulgaria', code: 'BG', nation: 'Bulgarian' },
  { name: 'Burkina Faso', code: 'BF', nation: 'Burkinabé' },
  { name: 'Burundi', code: 'BI', nation: 'Bahutu' },
  { name: 'Cambodia', code: 'KH', nation: 'Cambodian' },
  { name: 'Cameroon', code: 'CM', nation: 'Cameroonian' },
  { name: 'Canada', code: 'CA', nation: 'Canadian' },
  { name: 'Cape Verde', code: 'CV', nation: 'Cape Verdean' },
  { name: 'Cayman Islands', code: 'KY', nation: 'Caymanian' },
  { name: 'Central African Republic', code: 'CF', nation: 'Central African' },
  { name: 'Chad', code: 'TD', nation: 'Chadian' },
  { name: 'Chile', code: 'CL', nation: 'Chilean' },
  { name: 'China', code: 'CN', nation: 'Chinese' },
  { name: 'Christmas Island', code: 'CX', nation: 'Christmas Island' },
  { name: 'Cocos (Keeling) Islands', code: 'CC', nation: 'Cocos Malays' },
  { name: 'Colombia', code: 'CO', nation: 'Colombian' },
  { name: 'Comoros', code: 'KM', nation: 'Comorian' },
  { name: 'Congo', code: 'CG', nation: 'Congolese' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD', nation: 'The Republic of the Congo' },
  { name: 'Cook Islands', code: 'CK', nation: 'Cook Islander' },
  { name: 'Costa Rica', code: 'CR', nation: 'Ticos' },
  { name: 'Cote D\'Ivoire', code: 'CI', nation: 'Ivorians' },
  { name: 'Croatia', code: 'HR', nation: 'The Croats' },
  { name: 'Cuba', code: 'CU', nation: 'Cuban' },
  { name: 'Cyprus', code: 'CY', nation: 'Cypriot' },
  { name: 'Czech Republic', code: 'CZ', nation: 'The Czechs' },
  { name: 'Denmark', code: 'DK', nation: 'Danes' },
  { name: 'Djibouti', code: 'DJ', nation: 'Djiboutian' },
  { name: 'Dominican Republic', code: 'DM', nation: 'Dominican' },
  // { name: 'Dominican Republic', code: 'DO', nation: 'Dominicans' },
  { name: 'Ecuador', code: 'EC', nation: 'Ecuadorian' },
  { name: 'Egypt', code: 'EG', nation: 'Egyptian' },
  { name: 'El Salvador', code: 'SV', nation: 'Salvadorian' },
  { name: 'Equatorial Guinea', code: 'GQ', nation: 'Equatoguinean' },
  { name: 'Eritrea', code: 'ER', nation: 'Eritrean' },
  { name: 'Estonia', code: 'EE', nation: 'Estonian' },
  { name: 'Ethiopia', code: 'ET', nation: 'Ethiopian' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK', nation: 'Falkland Islander' },
  { name: 'Faroe Islands', code: 'FO', nation: 'Faroese' },
  { name: 'Fiji', code: 'FJ', nation: 'Fijian' },
  { name: 'Finland', code: 'FI', nation: 'Finns' },
  { name: 'France', code: 'FR', nation: 'French' },
  { name: 'French Guiana', code: 'GF', nation: 'French Guianan' },
  { name: 'French Polynesia', code: 'PF', nation: 'Tahitian' },
  { name: 'French Southern Territories', code: 'TF', nation: 'French Southern Territories' },
  { name: 'Gabon', code: 'GA', nation: 'Gabonese' },
  { name: 'Gambia', code: 'GM', nation: 'Gambian' },
  { name: 'Georgia', code: 'GE', nation: 'Georgian' },
  { name: 'Germany', code: 'DE', nation: 'German' },
  { name: 'Ghana', code: 'GH', nation: 'Ghanaian' },
  { name: 'Gibraltar', code: 'GI', nation: 'Gibraltarian' },
  { name: 'Greece', code: 'GR', nation: 'Greek' },
  { name: 'Greenland', code: 'GL', nation: 'Greenlander' },
  { name: 'Grenada', code: 'GD', nation: 'Grenadian' },
  { name: 'Guadeloupe', code: 'GP', nation: 'Guadeloupean' },
  { name: 'Guam', code: 'GU', nation: 'Chamorros' },
  { name: 'Guatemala', code: 'GT', nation: 'Guatemalan' },
  { name: 'Guernsey', code: 'GG', nation: 'Guernsey' },
  { name: 'Guinea', code: 'GN', nation: 'Guinean' },
  { name: 'Guinea-Bissau', code: 'GW', nation: 'Bissau-Guinean' },
  { name: 'Guyana', code: 'GY', nation: 'Guyanese' },
  { name: 'Haiti', code: 'HT', nation: 'Haitian' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM', nation: 'Australian (Heard Island and Mcdonald Islands)' },
  { name: 'Holy See (Vatican City State)', code: 'VA', nation: 'Papal Pontifical' },
  { name: 'Honduras', code: 'HN', nation: 'Honduran' },
  { name: 'Hong Kong', code: 'HK', nation: 'Hongkonger' },
  { name: 'Hungary', code: 'HU', nation: 'Hungarian' },
  { name: 'Iceland', code: 'IS', nation: 'Icelander' },
  { name: 'India', code: 'IN', nation: 'Indian' },
  { name: 'Indonesia', code: 'ID', nation: 'Indonesian' },
  { name: 'Iran, Islamic Republic Of', code: 'IR', nation: 'Persian' },
  { name: 'Iraq', code: 'IQ', nation: 'Iraqis' },
  { name: 'Ireland', code: 'IE', nation: 'Irish' },
  { name: 'Isle of Man', code: 'IM', nation: 'Manx' },
  { name: 'Israel', code: 'IL', nation: 'Israelis' },
  { name: 'Italy', code: 'IT', nation: 'Italian' },
  { name: 'Jamaica', code: 'JM', nation: 'Jamaican' },
  { name: 'Japan', code: 'JP', nation: 'Japanese' },
  { name: 'Jersey', code: 'JE', nation: 'Jèrriais' },
  { name: 'Jordan', code: 'JO', nation: 'Jordanian' },
  { name: 'Kazakhstan', code: 'KZ', nation: 'Kazakh' },
  { name: 'Kenya', code: 'KE', nation: 'Kenya' },
  { name: 'Kiribati', code: 'KI', nation: 'Gilbertese' },
  { name: 'Korea, Democratic People\'S Republic of', code: 'KP', nation: 'South Korean Korean' },
  { name: 'Korea, Republic of', code: 'KR', nation: 'South Korean' },
  { name: 'Kuwait', code: 'KW', nation: 'Kuwaiti' },
  { name: 'Kyrgyzstan', code: 'KG', nation: 'Kyrgyz' },
  { name: 'Lao People\'S Democratic Republic', code: 'LA', nation: 'Laotian' },
  { name: 'Latvia', code: 'LV', nation: 'Latvian' },
  { name: 'Lebanon', code: 'LB', nation: 'Lebanese' },
  { name: 'Lesotho', code: 'LS', nation: 'Basotho' },
  { name: 'Liberia', code: 'LR', nation: 'Liberian' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY', nation: 'Libyan' },
  { name: 'Liechtenstein', code: 'LI', nation: 'Liechtensteiner' },
  { name: 'Lithuania', code: 'LT', nation: 'Lithuanian' },
  { name: 'Luxembourg', code: 'LU', nation: 'Luxembourg' },
  { name: 'Macao', code: 'MO', nation: 'Macau' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK', nation: 'Macedonian' },
  { name: 'Madagascar', code: 'MG', nation: 'Malagasy' },
  { name: 'Malawi', code: 'MW', nation: 'Malawian' },
  { name: 'Malaysia', code: 'MY', nation: 'Malaysian' },
  { name: 'Maldives', code: 'MV', nation: 'Maldivian' },
  { name: 'Mali', code: 'ML', nation: 'Malian' },
  { name: 'Malta', code: 'MT', nation: 'Maltese' },
  { name: 'Marshall Islands', code: 'MH', nation: 'Marshallese' },
  { name: 'Martinique', code: 'MQ', nation: 'Martiniquais' },
  { name: 'Mauritania', code: 'MR', nation: 'Mauritanian' },
  { name: 'Mauritius', code: 'MU', nation: 'Mauritian' },
  { name: 'Mayotte', code: 'YT', nation: 'Mayotte' },
  { name: 'Mexico', code: 'MX', nation: 'Mexican' },
  { name: 'Micronesia, Federated States of', code: 'FM', nation: 'Micronesian' },
  { name: 'Moldova, Republic of', code: 'MD', nation: 'Moldovan' },
  { name: 'Monaco', code: 'MC', nation: 'Monacan' },
  { name: 'Mongolia', code: 'MN', nation: 'Mongolian' },
  { name: 'Montserrat', code: 'MS', nation: 'Montserratian' },
  { name: 'Morocco', code: 'MA', nation: 'Moroccan' },
  { name: 'Mozambique', code: 'MZ', nation: 'Mozambican' },
  { name: 'Myanmar', code: 'MM', nation: 'Burman' },
  { name: 'Namibia', code: 'NA', nation: 'Naman' },
  { name: 'Nauru', code: 'NR', nation: 'Nauruan' },
  { name: 'Nepal', code: 'NP', nation: 'Nepalis' },
  { name: 'Netherlands', code: 'NL', nation: 'The Dutch' },
  { name: 'Netherlands Antilles', code: 'AN', nation: 'Antilleans' },
  { name: 'New Caledonia', code: 'NC', nation: 'The Kanak' },
  { name: 'New Zealand', code: 'NZ', nation: 'New Zealanders' },
  { name: 'Nicaragua', code: 'NI', nation: 'Nicas' },
  { name: 'Niger', code: 'NE', nation: 'Nigerois' },
  { name: 'Nigeria', code: 'NG', nation: 'Nigerien' },
  { name: 'Niue', code: 'NU', nation: 'Niuean' },
  { name: 'Norfolk Island', code: 'NF', nation: 'Norfolk Islanders' },
  { name: 'Northern Mariana Islands', code: 'MP', nation: 'Northern Marianas' },
  { name: 'Norway', code: 'NO', nation: 'Norwegian' },
  { name: 'Oman', code: 'OM', nation: 'Omani' },
  { name: 'Pakistan', code: 'PK', nation: 'Pakistani' },
  { name: 'Palau', code: 'PW', nation: 'Palauan' },
  { name: 'Palestinian Territory, Occupied', code: 'PS', nation: 'Palestinians Israeli' },
  { name: 'Panama', code: 'PA', nation: 'Panamanian' },
  { name: 'Papua New Guinea', code: 'PG', nation: 'Papua New Guinean' },
  { name: 'Paraguay', code: 'PY', nation: 'Paraguayan' },
  { name: 'Peru', code: 'PE', nation: 'Peruvian' },
  { name: 'Philippines', code: 'PH', nation: 'Filipino' },
  { name: 'Pitcairn', code: 'PN', nation: 'Pitcairn Islanders' },
  { name: 'Poland', code: 'PL', nation: 'Polish' },
  { name: 'Portugal', code: 'PT', nation: 'Portuguese' },
  { name: 'Puerto Rico', code: 'PR', nation: 'Puerto Rican' },
  { name: 'Qatar', code: 'QA', nation: 'Qatari' },
  { name: 'Reunion', code: 'RE', nation: 'Reunion' },
  { name: 'Romania', code: 'RO', nation: 'Romanian' },
  { name: 'Russian Federation', code: 'RU', nation: 'Russian' },
  { name: 'RWANDA', code: 'RW', nation: 'Christmas' },
  { name: 'Saint Helena', code: 'SH', nation: 'Saint Helenian' },
  { name: 'Saint Kitts and Nevis', code: 'KN', nation: 'Kittitian' },
  { name: 'Saint Lucia', code: 'LC', nation: 'Saint Lucian' },
  { name: 'Saint Pierre and Miquelon', code: 'PM', nation: 'Saint-Pierrais Miquelonnais Pierrian' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC', nation: 'Vincentian' },
  { name: 'Samoa', code: 'WS', nation: 'Samoan' },
  { name: 'San Marino', code: 'SM', nation: 'Sammarinese' },
  { name: 'Sao Tome and Principe', code: 'ST', nation: 'Sao Tomean' },
  { name: 'Saudi Arabia', code: 'SA', nation: 'Saudi Arabian' },
  { name: 'Senegal', code: 'SN', nation: 'Senegalese' },
  { name: 'Serbia and Montenegro', code: 'CS', nation: 'Montenegrin' },
  { name: 'Seychelles', code: 'SC', nation: 'Seychellois' },
  { name: 'Sierra Leone', code: 'SL', nation: 'Sierra Leonean' },
  { name: 'Singapore', code: 'SG', nation: 'Singaporean' },
  { name: 'Slovakia', code: 'SK', nation: 'Slovak' },
  { name: 'Slovenia', code: 'SI', nation: 'Slovenian' },
  { name: 'Solomon Islands', code: 'SB', nation: 'Solomon Islander' },
  { name: 'Somalia', code: 'SO', nation: 'Somalian' },
  { name: 'South Africa', code: 'ZA', nation: 'South African' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS', nation: 'South Georgian South Sandwich Islander' },
  { name: 'Spain', code: 'ES', nation: 'Spanish' },
  { name: 'Sri Lanka', code: 'LK', nation: 'Sri Lankan' },
  { name: 'Sudan', code: 'SD', nation: 'Sudan' },
  { name: 'Suriname', code: 'SR', nation: 'Surinamese' },
  // { name: 'Svalbard and Jan Mayen', code: 'SJ', nation: 'Norwegian' },
  { name: 'Swaziland', code: 'SZ', nation: 'Swazi' },
  { name: 'Sweden', code: 'SE', nation: 'Swedish' },
  { name: 'Switzerland', code: 'CH', nation: 'Swiss' },
  { name: 'Syrian Arab Republic', code: 'SY', nation: 'Syrian' },
  { name: 'Taiwan, Province of China', code: 'TW', nation: 'Taiwan' },
  { name: 'Tajikistan', code: 'TJ', nation: 'Tajik' },
  { name: 'Tanzania, United Republic of', code: 'TZ', nation: 'Tanzanian' },
  { name: 'Thailand', code: 'TH', nation: 'Thai' },
  { name: 'Timor-Leste', code: 'TL', nation: 'East Timorese Timorese Maubere' },
  { name: 'Togo', code: 'TG', nation: 'Togolese' },
  { name: 'Tokelau', code: 'TK', nation: 'Tokelauan' },
  { name: 'Tonga', code: 'TO', nation: 'Batonga' },
  { name: 'Trinidad and Tobago', code: 'TT', nation: 'Trinidadian and Tobagonian' },
  { name: 'Tunisia', code: 'TN', nation: 'Tunisian' },
  { name: 'Turkey', code: 'TR', nation: 'Turkish' },
  { name: 'Turkmenistan', code: 'TM', nation: 'Turkmenistan' },
  { name: 'Turks and Caicos Islands', code: 'TC', nation: 'Belonger' },
  { name: 'Tuvalu', code: 'TV', nation: 'Tuvaluan' },
  { name: 'Uganda', code: 'UG', nation: 'Ugandan' },
  { name: 'Ukraine', code: 'UA', nation: 'Ukrainian' },
  { name: 'United Arab Emirates', code: 'AE', nation: 'Emiratis' },
  { name: 'United Kingdom', code: 'GB', nation: 'British' },
  { name: 'United States', code: 'US', nation: 'American' },
  { name: 'United States Minor Outlying Islands', code: 'UM', nation: 'American Islanders' },
  { name: 'Uruguay', code: 'UY', nation: 'Uruguayan' },
  { name: 'Uzbekistan', code: 'UZ', nation: 'Uzbekistani' },
  { name: 'Vanuatu', code: 'VU', nation: 'Vanuatuan' },
  { name: 'Venezuela', code: 'VE', nation: 'Venezuelan' },
  { name: 'Viet Nam', code: 'VN', nation: 'Vietnamese' },
  { name: 'Virgin Islands, British', code: 'VG', nation: 'British Virgin Islander' },
  { name: 'Virgin Islands, U.S.', code: 'VI', nation: 'Virgin Islander' },
  { name: 'Wallis and Futuna', code: 'WF', nation: 'Wallisian Futunan' },
  { name: 'Western Sahara', code: 'EH', nation: 'Saharawi' },
  { name: 'Yemen', code: 'YE', nation: 'Yemeni' },
  { name: 'Zambia', code: 'ZM', nation: 'Zambian' },
  { name: 'Zimbabwe', code: 'ZW', nation: 'Zimbabwean' },
];

export default countries;
